<template>
	<div class="pay-page">
		<Loader :show="loading" />

		<FormulateForm ref="form" v-model="form" @submit="save">
			<div class="pay-content">
				<div class="row">
					<div class="col-12 ">
						<div class="head">
							<h2 class="mt-4">Pago</h2>

							<div class="section-title">
								<div class="label">Método de pago</div>
							</div>
							<PaymentMethods @selected="selectedPaymentMethod" />
							<div class="text-danger" v-if="touched && !paymentMethod">
								Debe seleccionar un método de pago
							</div>
						</div>
					</div>

					<div class="col-12 col-md-6">
						<div class="side-content">
							<div class="section-title">
								<p class="text-white">.</p>
								<div class="label">Detalle del pedido</div>
							</div>
							<div class="mt-2 p-3">
								<CartProductsTable :cart="order" />
							</div>
						</div>
					</div>
					<div class="col-12 col-md-6">
						<div class="side-content mt-4">
							<div class="section-title">
								<div class="label">Información de facturación</div>
								<p>Complete sus datos personales para poder finalizar su compra</p>
							</div>

							<div class="p-3 mt-3">
								<FormulateInput
									type="identification"
									label="Documento de identidad"
									name="document"
									validation-name="Documento"
									validation="required|^documentID"
								/>

								<div class="row row-xs">
									<div class="col-12 col-md-6 mb-2">
										<FormulateInput
											label="País"
											validation-name="País"
											name="addressCountry"
											:options="countries"
											type="selectSearch"
											option-value="id"
											option-text="name"
											placeholder="Seleccione un país"
											validation="required"
										/>
									</div>
									<div class="col-12 col-md-6 mb-2">
										<FormulateInput
											label="Ciudad"
											name="addressCity"
											validation-name="Ciudad"
											validation="required"
										/>
									</div>
								</div>
								<FormulateInput
									label="Calle número, etc..."
									name="addressStreet"
									validation-name="Ciudad"
									validation="required"
									help="Dirección (calle, número, apartamento, etc...)"
								/>
							</div>

							<div
								class="p-3"
								v-if="
									paymentMethod &&
										(paymentMethod.code == 1 || paymentMethod.code == 2 || paymentMethod.code == 4)
								"
							>
								<FormulateInput
									label="Cuotas"
									v-model="installments"
									type="select"
									:options="[1, 3, 6]"
								/>
							</div>
						</div>
					</div>

					<div class="col-12" v-if="order">
						<div class="buttons mt-3">
							<div class="row">
								<div class="col-12 col-sm-6 order-sm-last mb-2">
									<FormulateInput type="submit" name="Finalizar compra">
										<template>
											<div class="btn btn-primary w-100">Finalizar compra</div>
										</template>
									</FormulateInput>
								</div>
								<div class="col-12 col-sm-6 order-sm-first text-center text-md-left mb-2">
									<router-link tag="a" :to="`/order/${order.code}`" class="btn btn-secondary"
										>Volver</router-link
									>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</FormulateForm>

		<BambooPayment
			v-if="order"
			:amount="order.priceTotal"
			:paymentMethod="paymentMethod"
			:client="order.client"
			:installments="installments"
			ref="PaymentComponent"
			@paymentDone="paymentDone"
			@paymentClosed="paymentClosed"
		/>
	</div>
</template>

<script>
import gql from "graphql-tag"
import ecommerceMixins from "./mixins"
import Loader from "@/components/Loader"
import CartProductsTable from "./CartProductsTable"
import PaymentMethods from "./PaymentMethods"
import BambooPayment from "./BambooPayment"

export default {
	name: "OrderPayment",
	mixims: [ecommerceMixins],
	components: { Loader, CartProductsTable, PaymentMethods, BambooPayment },
	data() {
		return {
			loading: true,
			opened: false,
			order: null,
			countries: [],
			form: {
				addressCountry: null,
				addressCity: null,
				addressStreet: null,
				document: {
					type: "UY",
					number: null
				}
			},
			installments: 1,
			paymentMethod: null,
			purchasing: false,
			touched: false,
			orderCreated: null
		}
	},
	async beforeMount() {
		console.log("beforeMount")
		await this.fetchData()
		await this.load()
		if (!this.order.canPay) this.$router.push(`/order/${this.order.code}`)
	},
	methods: {
		selectedPaymentMethod(method) {
			this.paymentMethod = method
		},
		paymentDone(data) {
			// console.log('paymentDone', data)
			this.purchasing = false
			this.$router.push(`/order/${this.order.code}`)
		},
		paymentClosed(paying) {
			// console.log('paymentClosed on Checkout detail', paying)
			this.purchasing = false
			if (!paying) this.$router.push(`/order/${this.order.code}`)
		},

		save() {
			console.log("save", this.form)

			if (!this.loading) {
				this.touched = true
				const paymentValidate = this.$refs.PaymentComponent.validate()

				if (paymentValidate.valid) {
					this.loading = true
					this.purchasing = true

					const data = {
						addressCountry: this.form.addressCountry,
						addressCity: this.form.addressCity,
						addressStreet: this.form.addressStreet,
						document: this.form.document
					}

					this.$apollo
						.mutate({
							mutation: gql`
								mutation($id: ID!, $data: ClientInput!) {
									clientUpdate(id: $id, data: $data) {
										id
									}
								}
							`,
							variables: {
								id: this.order.client.id,
								data
							}
						})
						.then(({ data }) => {
							this.$refs.PaymentComponent.proccessPayment(this.order.id)
						})
						.catch((err) => {
							console.log("error", err)
							this.loading = false
						})
				}
			}
		},

		load() {
			return this.$apollo
				.query({
					query: gql`
						query($code: String) {
							order(code: $code) {
								id
								code
								priceSubtotal
								priceTaxes
								priceTotal
								status
								statusText
								paymentStatus
								paymentStatusText
								canPay
								createdAt
								products {
									product {
										id
										name
										image {
											id
											urlThumb
										}
										category {
											id
											title
										}
									}
									qty
									priceUnit
									priceSubtotal
								}
								client {
									id
									name
									email
									document {
										type
										number
									}
									lastname
									addressCountry {
										id
										name
									}
									addressCity
									addressStreet
								}
								payments {
									id
									externalPaymentId
									amount
									installments
									acquirerName
									last4
									status
									statusText
									statusHelp
								}
							}
						}
					`,
					variables: { code: this.$route.params.code },
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.order = data.order
					this.form.document = data.order.client.document
						? { type: data.order.client.document.type, number: data.order.client.document.number }
						: { type: "UY", number: "" }
					this.form.addressCountry =
						data.order.client && data.order.client.addressCountry
							? data.order.client.addressCountry.id
							: null
					this.form.addressCity = data.order.client.addressCity
					this.form.addressStreet = data.order.client.addressStreet

					this.loading = false
				})
				.catch((err) => {
					console.log(err)
					// this.$router.push('/')
				})
		},

		fetchData() {
			return this.$apollo
				.query({
					query: gql`
						query {
							countries {
								id
								iso
								name
								nativeName
								flag
							}
						}
					`,
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.countries = data.countries
				})
				.catch((err) => {
					console.log(err)
				})
		}
	}
}
</script>
<style scoped>
.pay-page {
	width: 100%;
	height: 100%;
	position: fixed;
	padding: 18px;
	top: 0px;
	left: 0px;
	z-index: 1000;
	background-color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: auto;
}
.pay-content {
	max-width: 800px;
}

.section-title {
	display: flex;
	justify-content: center;
	min-height: 50px;
	flex-direction: column;
}
.section-title .label {
	font-size: 18px;
	font-weight: 500;
	line-height: 18px;
}
.section-title p {
	margin: 0px;
	color: #888;
}

.head {
	margin: auto;
	max-width: 400px;
}
.side-content {
	margin: auto;
	max-width: 400px;
}

.buttons {
	margin: auto;
	max-width: 400px;
}

@media (min-width: 768px) {
	.buttons {
		max-width: 100%;
	}

	.head {
		max-width: 100%;
	}
}
</style>
